import { render, staticRenderFns } from "./VaFileUploadUndo.vue?vue&type=template&id=0d8e2f92&scoped=true&"
import script from "./VaFileUploadUndo.vue?vue&type=script&lang=js&"
export * from "./VaFileUploadUndo.vue?vue&type=script&lang=js&"
import style0 from "./VaFileUploadUndo.vue?vue&type=style&index=0&id=0d8e2f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8e2f92",
  null
  
)

export default component.exports